const getReviewsByPlaceId = (reviews: Review[]): {[placeId: string]: Review} =>
  reviews.reduce((acc, review) => {
    if (!review.place) return acc;
    acc[review.place] = review;
    return acc;
  }, {} as {[placeId: string]: Review});

export default getReviewsByPlaceId;
